import { Overline } from "@/components/dash/primitives";

export function StatCard({ stat, testid }) {
  return (
    <div
      data-testid={testid}
      className="bg-white border border-slate-200 rounded-xl p-6 flex flex-col transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:border-slate-300"
    >
      <div className="font-display text-4xl sm:text-5xl font-bold tracking-tighter text-slate-900">
        {stat.value}
      </div>
      <div
        className={`font-num text-sm font-semibold mt-2 ${
          stat.positive ? "text-emerald-600" : "text-orange-600"
        }`}
      >
        {stat.indicator}
      </div>
      <p className="text-sm text-slate-600 mt-3 leading-relaxed flex-1">{stat.desc}</p>
      <Overline className="mt-4 !text-[10px] text-slate-400">{stat.source}</Overline>
    </div>
  );
}
